import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Resultstock() {
  return (
    <section className="result_stock p-100 text_white bg_stock text_stock">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              THE <span>RESULTS</span>
            </h2>
            <p>
              Our product development and technical consultancy led to the
              development of Stock n Ship, a platform where businesses can
              comprehensively oversee their store through portals.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/stock/result_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1908}
                height={1048}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultstock;
